import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_DATA_FACT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import FactInstance from '../fact-checkbox/fact-instance'
import produce from 'immer'
import Icon from '../../../Icon'
import { getComponentLabel } from '../../helper'

/**
 * This component renders a fact instance without the header [the checkbox etc]
 * The components are rendered as usual. The removal of the attributes leads to the removal of the fact.
 * This is currently used only for the currency code fact.
 *
 * Caveat: having more than one attribute in the components can break things
 * So these are filtered out.
 */
const FactSingleAttributeControlled = ({
                                         blueprint,
                                         factsheetBlueprint,
                                         data,
                                         validationStatus,
                                         deleteFact,
                                         putFactInstance,
                                         putFactInstanceExpandedStatus
                                       }) => {
  const onSelectedVariantsChange = useCallback((selectedVariantIds, factInstanceIndex) => {
    putFactInstance(
      blueprint.id,
      factInstanceIndex,
      produce(data[factInstanceIndex], draft => {
        draft.appliesTo = selectedVariantIds
      })
    )
  }, [putFactInstance, data, blueprint.id])

  const afterDeleteAttribute = useCallback(() => {
    deleteFact(blueprint.id)
  }, [deleteFact, blueprint.id])

  const key = 0
  const factDefId = blueprint.id
  let instanceValidationStatus = undefined

  if (typeof validationStatus !== 'undefined') {
    instanceValidationStatus = validationStatus.factInstances[key]
  }

  const fact = factsheetBlueprint.factTree.facts[factDefId]
  const showActions = !!fact.definition
  const label = getComponentLabel(blueprint, fact)

  return (
    <div className={'fact-single-attribute-controlled'}>
      <div className={'fact-single-attribute-controlled-header'}>
        {label}
        {showActions && (
          <div className={'fact-single-attribute-controlled-actions'}>
            {fact.definition && <Icon type={'how'} tooltip={fact.definition}/>}
          </div>
        )}
      </div>
      <FactInstance
        key={key}
        withHeader={false}
        blueprint={blueprint}
        data={data ? data[key] : {
          'factDefId': factDefId,
          'attributes': {},
          'appliesTo': []
        }}
        factsheetBlueprint={factsheetBlueprint}
        onFactInstanceDeleteClick={() => {}}
        putFactInstanceExpandedStatus={putFactInstanceExpandedStatus}
        onSelectedVariantsChange={onSelectedVariantsChange}
        validationStatus={instanceValidationStatus}
        collapsed={false}
        index={key}
        allowToggle={false}
        afterDeleteAttribute={afterDeleteAttribute}
      />
    </div>
  )
}

FactSingleAttributeControlled.propTypes = {
  blueprint: PropTypes.shape({ components: PropTypes.array.isRequired }).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(SHAPE_DATA_FACT)),
  validationStatus: PropTypes.object,
  deleteFact: PropTypes.func.isRequired,
  addFactInstance: PropTypes.func.isRequired,
  putFactInstance: PropTypes.func.isRequired,
  putFactInstanceExpandedStatus: PropTypes.func.isRequired,
  deleteFactInstance: PropTypes.func.isRequired,
  expandedFactInstances: PropTypes.array,
}

export default withTranslation()(FactSingleAttributeControlled)
